export const DriveUrl = '/drive';
export const PreviewUrl = '/weboffice';

export const PreviewBusinessCode = 'wps.preview.drive.share';
export const PreviewSuffix = '/v1/view/preview';
